var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "el-dialog3",
          attrs: {
            title: "机构管理员账号（手机号）改绑申请",
            visible: _vm.dialogVisible,
            width: "25%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("p", { staticClass: "p1", staticStyle: { width: "1.2rem" } }, [
                _c("span", [_vm._v("*")]),
                _vm._v("旧登录手机"),
              ]),
              _c("el-input", {
                staticStyle: { width: "2.3rem" },
                attrs: { size: "small", placeholder: "验证旧密码" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("p", { staticClass: "p1", staticStyle: { width: "1.2rem" } }, [
                _vm._v("新登录手机"),
              ]),
              _c("el-input", {
                staticStyle: { width: "2.3rem" },
                attrs: { size: "small", placeholder: "请设置新密码" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("div", { staticClass: "btns5" }, [_vm._v("获取验证码")]),
              _c("el-input", {
                staticStyle: { width: "2.3rem" },
                attrs: { size: "small", placeholder: "请再次输入新密码" },
              }),
            ],
            1
          ),
          _c("p", { staticClass: "p1", staticStyle: { margin: "0.24rem 0" } }, [
            _vm._v(" 请输入更换机构管理员账号（手机号）的理由 "),
          ]),
          _c("el-input", {
            attrs: { type: "textarea", autosize: { minRows: 3, maxRows: 5 } },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btns6",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确认申请更换成新的登录手机号")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }